module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "login-form-title"
  }, [_vm._v(_vm._s(_vm.i18n.login.signup))]), _vm._v(" "), _c('Form', {
    ref: "loginData",
    attrs: {
      "model": _vm.loginData,
      "rules": _vm.loginDataRules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n.login.email,
      "icon": "ios-email",
      "size": "large"
    },
    model: {
      value: (_vm.loginData.email),
      callback: function($$v) {
        _vm.loginData.email = $$v
      },
      expression: "loginData.email"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "user"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n.login.user,
      "icon": "android-contact",
      "size": "large"
    },
    model: {
      value: (_vm.loginData.user),
      callback: function($$v) {
        _vm.loginData.user = $$v
      },
      expression: "loginData.user"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "password",
      "placeholder": _vm.i18n.login.password,
      "icon": "locked",
      "size": "large"
    },
    model: {
      value: (_vm.loginData.password),
      callback: function($$v) {
        _vm.loginData.password = $$v
      },
      expression: "loginData.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "passwordTwice"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "password",
      "placeholder": _vm.i18n.login.passwordTwice,
      "icon": "locked",
      "size": "large"
    },
    model: {
      value: (_vm.loginData.passwordTwice),
      callback: function($$v) {
        _vm.loginData.passwordTwice = $$v
      },
      expression: "loginData.passwordTwice"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    staticClass: "login-form-button no-circle",
    attrs: {
      "type": "primary",
      "size": "large",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.submitOnClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.login.signup))]), _vm._v(" "), _c('Row', {
    staticClass: "login-form-links-group"
  }, [_c('Col', {
    staticClass: "text-align-center",
    attrs: {
      "span": "24"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/welcome"
    }
  }, [_vm._v(_vm._s(_vm.i18n.backToMain))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f4435c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome/SignUp.vue
// module id = 395
// module chunks = 0